import { render, staticRenderFns } from "./UpsellButtonTab.vue?vue&type=template&id=71a54622"
import script from "./UpsellButtonTab.vue?vue&type=script&lang=js"
export * from "./UpsellButtonTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports